import { connect } from 'react-redux';
import set from 'lodash/set';
import clone from 'lodash/cloneDeep';
import { v4 as uuidv4 } from 'uuid';
import View from './AccountAddEditView';
import {
  save,
  updateValidation,
  fetchData,
  updateSupportData,
} from '../../../AdvWorkflow/AdvWorkflowActions';
import {
  setViewId,
  updateDraftAccount,
  saveDraftAccount,
  addDraftAccount,
  setDraftAccount,
} from './AccountsStepActions';
import { OVERVIEW } from './AccountsStepViews';
import { currentClientId, iterator } from '../../../AdvWorkflow/AdvWorkflowSelector';
import {
  BACKEND_KEY,
  DOLLAR_CONTRIBUTION,
  PERCENTAGE_CONTRIBUTION,
} from '../../AccountsWorkflowConstants';
import {
  groupsSelector,
  contributionSelector,
  contributionTypeSelector,
  accountTypesOptionsSelector,
  accountOwnersOptionsSelector,
  accountOwnersGroupsSelector,
  accountDraftSelector,
  nullableAccountTypeOptionSelector,
  nullableAccountOwnerOptionSelector,
  contributionLabelSelector,
  dollarContributionKeyNameSelector,
  percentageContributionTitleSelector,
  percentageContributionKeyNameSelector,
  isEmployerSponsoredRetirementAccountSelector,
  isEmployerMatchableRetirementAccountSelector,
  hasMaximizeContributionsSelector,
  contributionPeriodSelector,
  hasContributionPeriodOptionSelector,
  canEmployeeMaxContributionSelector,
  hasContributionPercentOptionSelector,
  accountTypesSelector,
  accountOwnersSelector,
  ownerModelSelector,
} from './AccountAddEditSelector';

import { accountsSelector } from './AccountsStepSelector';
import workflowAnalyticsEvents from '../../../AnalyticsWorkflow/AnalyticsWorkflow';
import { onCancel as onCancelAddOrEdit } from './AccountAddEditActions';
import { mapEmployerMatchData } from '../../../SharedComponents/EmployerMatch/EmployerMatchUtils';
import { bindActionCreators } from 'redux';

const TaxStatusMap = {
  PreTax: 0,
  Roth: 1,
  AfterTax: 2,
  Mix: 3,
};

const mapStateToProps = (state, ownProps) => ({
  clientId: currentClientId(state, ownProps),
  iterator: iterator(state, ownProps),
  account: accountDraftSelector(state, ownProps),

  graphAccounts: accountsSelector(state, ownProps),

  accountTypeOption: nullableAccountTypeOptionSelector(state, ownProps),
  accountOwnerOption: nullableAccountOwnerOptionSelector(state, ownProps),

  groups: groupsSelector(state, ownProps),
  accountOwnersGroups: accountOwnersGroupsSelector(state, ownProps),

  contribution: contributionSelector(state, ownProps),
  contributionType: contributionTypeSelector(state, ownProps),
  accountTypes: accountTypesSelector(state, ownProps),
  accountTypesOptions: accountTypesOptionsSelector(state, ownProps),
  accountOwnersOptions: accountOwnersOptionsSelector(state, ownProps),
  contributionLabel: contributionLabelSelector(state, ownProps),
  dollarContributionKeyName: dollarContributionKeyNameSelector(state, ownProps),

  percentageContributionTitle: percentageContributionTitleSelector(state, ownProps),
  percentageContributionKeyName: percentageContributionKeyNameSelector(state, ownProps),

  isEmployerSponsoredRetirementAccount: isEmployerSponsoredRetirementAccountSelector(
    state,
    ownProps,
  ),
  isEmployerMatchableRetirementAccount: isEmployerMatchableRetirementAccountSelector(
    state,
    ownProps,
  ),

  canEmployeeMaxContribution: canEmployeeMaxContributionSelector(state, ownProps),
  hasMaximizeContributions: hasMaximizeContributionsSelector(state, ownProps),
  contributionPeriod: contributionPeriodSelector(state, ownProps),
  hasContributionPeriodOption: hasContributionPeriodOptionSelector(state, ownProps),
  hasContributionPercentOption: hasContributionPercentOptionSelector(state, ownProps),
  accountOwners: accountOwnersSelector(state, ownProps),
  ownerModel: ownerModelSelector(state, ownProps),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  onSave: bindActionCreators(
    (baseAccount, graphAccounts, workflowId, clientId) => () => {
      const taxStatusKey = Object.keys(TaxStatusMap);

      let newAccount;
      let rollbackAccount;

      const isTaxStatusMix = baseAccount.TaxStatus === TaxStatusMap.Mix;
      const earmarkPossibleTaxStatus = taxStatusKey.filter(key => key !== 'Mix');

      const account = {
        ...baseAccount,

        Balances: {
          Unit: baseAccount.Balances.Unit,
          ...(baseAccount.TaxStatus >= 0
            ? {
                ...(isTaxStatusMix
                  ? earmarkPossibleTaxStatus.reduce(
                      (acc, key) => ({
                        ...acc,
                        [key]: {
                          Earmarks: baseAccount.AccountEarmark,
                          ...baseAccount.Balances[key],
                        },
                      }),
                      {},
                    )
                  : {
                      [earmarkPossibleTaxStatus[baseAccount.TaxStatus]]: {
                        ...baseAccount.Balances[earmarkPossibleTaxStatus[baseAccount.TaxStatus]],
                        Earmarks: baseAccount.AccountEarmark,
                      },
                    }),
              }
            : {}),
        },
      };

      if (!account.AccountId && !account.frontEndId) {
        newAccount = clone(account);
        newAccount.frontEndId = uuidv4();
        dispatch(addDraftAccount(newAccount, graphAccounts, workflowId, clientId));
      } else {
        rollbackAccount = graphAccounts.find(({ AccountId }) => AccountId === account.AccountId);
        dispatch(saveDraftAccount(account, graphAccounts, workflowId, clientId));
      }

      const onSuccess = () => {
        dispatch(fetchData(workflowId, clientId, [BACKEND_KEY]));
        dispatch(setViewId(OVERVIEW, workflowId, clientId));
        dispatch(
          updateValidation(set({}, `${BACKEND_KEY}.AccountAddEdit`, []), workflowId, clientId),
        );
        if (newAccount) {
          workflowAnalyticsEvents(workflowId, 'account_added');
        }
      };
      const onFailure = errors => {
        const contentEl = document.getElementById('content');

        if (contentEl) {
          contentEl.scrollTo(0, 0);
        }

        dispatch(
          updateValidation(set({}, `${BACKEND_KEY}.AccountAddEdit`, errors), workflowId, clientId),
        );
        if (newAccount) {
          dispatch(setDraftAccount(newAccount, workflowId, clientId));
        }

        if (rollbackAccount) {
          dispatch(saveDraftAccount(rollbackAccount, graphAccounts, workflowId, clientId));
        }
      };
      const isLastStep = false;
      const onPostProcess = null;
      const onPostSave = accounts => {
        dispatch(
          updateSupportData(
            {
              [BACKEND_KEY]: {
                HasYourFamilyStartedSaving: accounts && accounts.length !== 0,
              },
            },
            workflowId,
            clientId,
          ),
        );
      };

      dispatch(
        save(
          BACKEND_KEY,
          onSuccess,
          onFailure,
          workflowId,
          clientId,
          isLastStep,
          onPostProcess,
          onPostSave,
        ),
      );
    },
    dispatch,
  ),
  onCancel: (workflowId, clientId, accountDraft, graphAccounts) => () => {
    dispatch(onCancelAddOrEdit(workflowId, clientId, accountDraft, graphAccounts));
  },
  updateDraftAccount(updates) {
    dispatch(updateDraftAccount(updates, ownProps.workflowId, ownProps.clientId));
  },
  accountInputChanged: (path, workflowId, clientId) => event => {
    dispatch(updateDraftAccount(set({}, path, event.target.value), workflowId, clientId));
  },
  accountSimpleSelectChanged: (path, workflowId, clientId) => value => {
    dispatch(updateDraftAccount(set({}, path, (value || {}).value || null), workflowId, clientId));
  },
  accountTypeChanged: (workflowId, clientId) => value => {
    if (value) {
      dispatch(updateDraftAccount(value.extra, workflowId, clientId));
    } else {
      dispatch(updateDraftAccount(set({}, 'AccountType', null), workflowId, clientId));
    }
  },
  contributionTypeChanged: (type, workflowId, clientId) => () => {
    const newContributionValues = {
      ContributionAmount: null,
      ContributionPercent: null,
      EmployerMatchAmount: null,
      EmployerMatchPercent: null,
    };
    if (type === PERCENTAGE_CONTRIBUTION) {
      newContributionValues.ContributionPercent = '0';
      newContributionValues.EmployerMatchPercent = '0';
    } else if (type === DOLLAR_CONTRIBUTION) {
      newContributionValues.ContributionAmount = '0';
      newContributionValues.EmployerMatchAmount = '0';
    }
    dispatch(updateDraftAccount(newContributionValues, workflowId, clientId));
  },
  mapEmployerMatch: (account, workflowId, clientId) => {
    const mappedData = mapEmployerMatchData(account);
    if (mappedData) {
      const newData = { EmployerMultiTierMatch: mappedData };
      dispatch(updateDraftAccount(newData, workflowId, clientId));
    }
  },
});

const AccountAddEditContainer = connect(mapStateToProps, mapDispatchToProps)(View);

export default AccountAddEditContainer;
